import { posthog } from "posthog-js";
import { useEffect } from "react";
import { useGetUserQuery } from "views/auth/query/user.query";

function useInitiatePostHog() {
  const { data: user } = useGetUserQuery();

  useEffect(() => {
    if (user?.email) {
      const { _id, email, firstName, lastName } = user;
      posthog.identify(_id.toString(), {
        email,
        name: `${firstName} ${lastName}`,
      });
    }
  }, [user]);
}

export default useInitiatePostHog;
